import animateOnScroll from "./animateOnScroll"
import Glide from '@glidejs/glide'
import Rellax from 'rellax'
//animate elements
/*---------------
Notes
-----------------
Offset:
- .5 means half of the element is visible before triggering
- 1 means 100% of the element should be visible
- 0 would be if any part of the element is visible 
CSS animations:
- make sure that the transformX/Y is not too large otherwise it will take forever to animate in
*/
animateOnScroll([
    { selector: ".fact img", offset: 0.25, multiple: true },
    { selector: ".logo", offset: 0.25, multiple: true },
    { selector: ".highlight-orange", offset: 0.25, multiple: true },
    { selector: ".highlight-white", offset: 0.25, multiple: true },
    { selector: ".home .info ul li", offset: 0.25, multiple: true },
    { selector: ".home .about h3", offset: 0.25, multiple: true },
    { selector: ".story .share", offset: 0.25, multiple: true },
    { selector: ".michael-sm", offset: 0.25, multiple: true },
]);


if (document.querySelector('#QuotesGlide')) {
    const el = document.querySelector('#QuotesGlide');
    const quoteSlider = new Glide(el, {
        type: 'carousel',
        perView: 1,
    });
    quoteSlider.mount();
}

if (document.querySelector('#NewsGlide')) {
    const el = document.querySelector('#NewsGlide');
    const logoSlider = new Glide(el, {
        type: 'carousel',
        perView: 2,
        breakpoints: {
            992: {
                perView: 2
            },
            576: {
                perView: 1
            },
        }
    });
    logoSlider.mount();
}
if (document.querySelector('#ov-slider')) {
    const el = document.querySelector('#ov-slider');
    const ovSlider = new Glide(el, {
        type: 'carousel',
        perView: 4,
        peek: { before: 0, after: 100 },
		breakpoints: {
			1400: {
				perView: 4,
				peek: { before: 0, after: 50 },
			},
			1100: {
				perView: 3,
				peek: { before: 0, after: 0 },
			},
			768: {
				perView: 2,
				peek: { before: 0, after: 0 },
			},
			590: {
				perView: 2,
				peek: { before: 0, after: 0 },
			},
			540: {
				perView: 1,
				peek: { before: 0, after: 0 },
			},
		},
    });
    ovSlider.mount();
}

const aboutParallax = new Rellax('.michael', {
    wrapper: '.about'
});

const joinParallax = new Rellax('.join .parallax');
document.addEventListener('DOMContentLoaded', function () {
    aboutParallax.refresh();
    joinParallax.refresh();
});

const setEqualSlideHeights = () => {
	const slides = document.querySelectorAll('.ov-slide');

	let maxHeight = 0;

	// Loop through each slide and find the tallest one
	slides.forEach(slide => {
		const slideHeight = slide.offsetHeight; // Get the height of the slide
		if (slideHeight > maxHeight) {
			maxHeight = slideHeight; // Update maxHeight if this slide is taller
		}
	});

	// Set the min-height of all slides to the tallest height found
	slides.forEach(slide => {
		slide.style.minHeight = `${maxHeight}px`; // Apply the tallest height as min-height
	});
};

document.addEventListener('DOMContentLoaded', () => {
	setEqualSlideHeights();
    setTimeout(() => {
        setEqualSlideHeights();
    }, 500);
});

window.addEventListener('resize', () => {
	setEqualSlideHeights();
    setTimeout(() => {
        setEqualSlideHeights();
    }, 500);
});